// src/firebase.js
import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  GoogleAuthProvider,
  OAuthProvider,
} from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  CACHE_SIZE_UNLIMITED,
} from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// === Your existing config (unchanged) ===
const firebaseConfig = {
  apiKey: "AIzaSyDH2lTveCZpFl-2nPPuwbg8fFkLZLNbaU0",
  authDomain: "simple-business-by-oa.firebaseapp.com",
  projectId: "simple-business-by-oa",
  storageBucket: "simple-business-by-oa.appspot.com",
  messagingSenderId: "721302567263",
  appId: "1:721302567263:web:778b208a0b041c4ec0deea",
  measurementId: "G-Q9HDCVDPW9"
};

// Single app instance (prevents double init on hot reload)
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Firestore: bigger cache + offline persistence via the current API
// (enableIndexedDbPersistence was deprecated in Firebase v10). The multi-tab
// manager keeps cache consistent across tabs; it silently no-ops where
// IndexedDB isn't available (e.g. private mode), so the app still works.
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    cacheSizeBytes: CACHE_SIZE_UNLIMITED,
    tabManager: persistentMultipleTabManager(),
  }),
});

// Auth: persist sessions across reloads
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);

// Cloud Functions: pin to your default region (change if you deployed elsewhere)
const functions = getFunctions(app, 'us-central1');

// Providers (re-use the same instances)
const googleProvider = new GoogleAuthProvider();
const appleProvider  = new OAuthProvider('apple.com');

export { app, auth, db, functions, googleProvider, appleProvider };
